import axios from 'axios';

import errorHandler from './errorHandler';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

instance.interceptors.response.use(response => response, errorHandler);

export { default as setAuthorizationHeader } from './setAuthorizationHeader';

export default instance;
